import VideoPopup from './VideoPopup';

export default VideoPopup;
